import { parsePhoneNumberFromString, CountryCode } from 'libphonenumber-js';

/**
 * Checks if the provided number is a valid phone number for the given country.
 * @param number - The phone number string to validate.
 * @param country - A valid ISO country code like 'US', 'PK', 'GB'.
 * @returns True if valid, false otherwise.
 */
export const isPossiblePhoneNumber = (number: string, country: CountryCode): boolean => {
  try {
    const phoneNumber = parsePhoneNumberFromString(number, country);
    return phoneNumber?.isValid() ?? false;
  } catch {
    return false;
  }
};
